<template>
  <el-row type="flex" justify="center" align="middle" :class="classComputed">
    <slot>
      <template v-if="type == 'fa' && !!icon">
        <font-awesome-icon :icon="icon" :size="sizeComputed"></font-awesome-icon>
      </template>
      <template v-if="type == 'el' && !!icon">
        <el-button type="text" circle plain :size="sizeComputed"></el-button>
      </template>
    </slot>
  </el-row>
</template>

<script>
export default {
  name: "TgToolbarBtn",
  props: {
    icon: String,
    type: {
      type: String,
      default() {
        return "fa";
      }
    },
    size: String,
    disabled: Boolean
  },
  computed: {
    classComputed() {
      return [
        "tg-toolbar--btn",
        this.icon,
        "tg-toolbar--btn-" + this.sizeComputed,
        {
          "is-disabled": this.disabled
        }
      ];
    },
    sizeComputed() {
      switch (this.type) {
        default:
          return this.size ? this.size : "lg";
        case "el":
          return this.size ? this.size : "medium";
      }
    }
  }
};
</script>